import https from "./https";
import store from "@/store"

const organization = store.state.general.organization;

export default {
  getPersonalPoints(merchantId, params) {
    return https.get(`admin/organizations/${organization.id}/merchants/${merchantId}/personal-points`, {
      params,
    });
  },
  exportPersonalPoints(merchantId, params) {
    const url = `admin/organizations/${organization.id}/merchants/${merchantId}/personal-points/export?${params}`;

    return https.get(url, {
      responseType: 'blob',
    });
  },
};
